import React from 'react';

const DEFAULT_ICON_SIZE = 16;

type Props = {
  className?: string;
};

const CheckIconBold = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={DEFAULT_ICON_SIZE}
      height={DEFAULT_ICON_SIZE}
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M4.5 7.57558L7.07558 10.1512L12.2267 5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CheckIconBold.ICON_SIZE = DEFAULT_ICON_SIZE;

export default CheckIconBold;
